import { render, staticRenderFns } from "./AnswerDetailServiceDetail.vue?vue&type=template&id=67f2f145&scoped=true&"
import script from "./AnswerDetailServiceDetail.vue?vue&type=script&lang=js&"
export * from "./AnswerDetailServiceDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f2f145",
  null
  
)

export default component.exports